module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Fire-9d22ffef844c7c5d1df788564c3483eb.svg";